import BModal from "@/components/singles/BModal/component.vue";
import BForm from "@/components/singles/BForm/component.vue";
import PaymentMethods from "@/components/main/user/paymentmethods/component.vue";
import AddPaymentMethod from "@/components/main/user/addpaymentmethod/component.vue";

export default {
  name: "",
  components: {
    BModal,
    BForm,
    PaymentMethods,
    AddPaymentMethod,
  },
  props: [
    "modalBtn",
    "actionBtn",
    "actionBtnReady",
    "loading",
    "publicKey",
    "billing",
    "readyBtnCss",
    "disabled",
  ],
  data() {
    return {
      noCards: false,
      showAddPaymentMethod: false,
      showModal: false,
      paymentMethodIsSelected: false,
      paymentMethod: null,
    };
  },
  computed: {},
  async created() {},
  async mounted() {},
  methods: {
    async Reset() {
      this.$set(this, "showModal", false);
      this.paymentMethod = null;
      this.noCards = false;
      this.showAddPaymentMethod = false;
      this.paymentMethodIsSelected = false;
    },

    async Show() {
      if (!this.publicKey || this.loading || this.disabled) return;

      if (this.publicKey) {
        this.$set(this, "showModal", true);
      }
    },

    Pay() {
      if (this.disabled) return;

      this.$emit("ready", this.paymentMethod);
      this.Reset();
    },
  },
};
